import { getItem } from '../storage';

export const getUserData = (onAdminSide: boolean) => {
    const representedUser = getItem('originalUser');
    const lqaRepresntedUser = getItem('lqaUser');
    if (onAdminSide && lqaRepresntedUser) {
        return lqaRepresntedUser.user;
    } else if (onAdminSide && representedUser) {
        return representedUser.user;
    } else {
        return getItem('user').user;
    }
};
